import { Button, Card, Col, DatePicker, Dropdown, Form, Input, Menu, message, Modal, Popconfirm, Row, Space, Table, Tooltip, Upload } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { useEffect, useState } from 'react';
import { getResource } from '../../util/getResourcePermission';
import config from "../../permission/config.json";
import { EditOutlined, EyeOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { AiOutlineDelete } from 'react-icons/ai';
import Service from '../../service';
import { useDispatch, useSelector } from 'react-redux';
import { hideAuthLoader, showAuthLoader } from '../../appRedux/actions/Auth';
import moment from "moment";
import { Tag } from "antd";
import { getRoles } from '../../util/getRoles';
import DeleteIcon from '../../assets/images/DeleteIcon';
import EditIcon from '../../assets/images/EditIcon';
import ViewIcon from '../../assets/images/ViewIcon';
import { capitalizeFirst } from '../../util/YearOptions';
import { FaEllipsisVertical } from 'react-icons/fa6';
import { useHistory } from 'react-router-dom';
import NodataFoundIcon from '../../assets/images/NodataFoundIcon';
import ApprovalStatusCell from '../Approvals/ApprovalStatusCell';
import ColumnSelector from '../common/ColumnSelector';
import useColumnVisibility from '../../hooks/useColumnVisibility';
import useCompanyDateFormat from '../../hooks/useCompanyDateFormat';
import { TABLE_PAGINATION, DEFAULT_PAGE_SIZE } from '../../constants/tablePagination';

const { RangePicker } = DatePicker;

const BillReimbursement = () => {
    const dateFormat = useCompanyDateFormat();
    const history = useHistory();
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const Search = Input.Search;
    const [searchRef, setsearchRef] = useState("")
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: DEFAULT_PAGE_SIZE,
    });
    const [filterData, setFilterData] = useState(null);
    // Which single menu (a row's "More Actions" dropdown or the toolbar's
    // Columns picker) is open - controlling them off one key keeps at most
    // one overlay on screen at a time, and closes a row's dropdown when the
    // toolbar's Columns menu opens (and vice versa).
    const [openMenuKey, setOpenMenuKey] = useState(null);
    const [openPopoverId, setOpenPopoverId] = useState(null);
    const formValues = Form.useWatch([], form);
    const hasAnyValue = formValues
        ? Object.values(formValues).some((v) => v !== undefined && v !== null && v !== "" && (Array.isArray(v) ? v.length > 0 : true))
        : false;

    const [reimbursementData, setReimbursementData] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState({});
    const [attachments, setAttachments] = useState([]);
    const [deletedAttachments, setDeletedAttachments] = useState([]);

    const [addForm] = Form.useForm();
    const [editForm] = Form.useForm();
    const [viewForm] = Form.useForm();

    const dispatch = useDispatch();
    const { authUser } = useSelector(({ auth }) => auth);
    const companySlug = localStorage.getItem("companyDomain");

    const getStatusTag = (status) => {

        let color = "default";
        switch (status?.toLowerCase()) {
            case "pending":
                color = "orange";
                break;
            case "approved":
                color = "green";
                break;
            case "rejected":
                color = "red";
                break;
            default:
                color = "blue";
        }
        return <Tag color={color}>{status || "-"}</Tag>;
    };
    const onSelectChange = (selectedKeys) => {
        setSelectedRowKeys(selectedKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const handleToolbarMenuOpenChange = (key, visible) => {
        if (visible) {
            setOpenPopoverId(null);
            setOpenMenuKey(key);
        } else if (openMenuKey === key) {
            setOpenMenuKey(null);
        }
    };

    useEffect(() => {
        const handleScroll = (event) => {
            // Scrolling inside the Columns dropdown's own checkbox list shouldn't
            // close it - only the underlying page/table scrolling should.
            if (event?.target?.closest?.('.column-selector-menu')) return;
            if (openPopoverId !== null) {
                setOpenPopoverId(null);
            }
            if (openMenuKey !== null) {
                setOpenMenuKey(null);
            }
        };

        // antd's popup doesn't reliably reposition on scroll here, so force-close
        // any open menu instead of letting it float away from its trigger.
        window.addEventListener('scroll', handleScroll, true);

        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [openPopoverId, openMenuKey]);

    const columns = [
        {
            title: 'Claim Code',
            dataIndex: 'claimCode',
            key: 'claimCode',
            width: 140,
            render: (text) => text || '-',
        },
        {
            title: 'Project/Event Name',
            dataIndex: 'title',
            key: 'title',
            width: 200,
            render: (title) => title || '-',
        },
        {
            title: 'Application Date',
            dataIndex: 'applicationDate',
            key: 'applicationDate',
            width: 130,
            render: (date) => moment(date).format(dateFormat),
        },
        {
            title: 'Total Amount',
            dataIndex: 'totalAmount',
            key: 'totalAmount',
            width: 140,
            render: (amount) => `₹${amount?.toFixed(2) || '0.00'}`,
        },
        {
            title: 'Status',
            dataIndex: 'statusFinal',
            key: 'statusFinal',
            width: 160,
            render: (status, record) =>
                record?.approval_progress ? <ApprovalStatusCell progress={record.approval_progress} /> : getStatusTag(status),
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            width: 100,
            className: "actions-column",

            // render: (text, record) => {
            // const actions = [];

            // // Edit Action (if not approved and has permission)
            // if (record.statusFinal !== "Approved" && record.statusbyRM != "Approved") {
            // actions.push({
            //     key: "edit",
            //     label: "Edit",
            //     icon: <EditIcon style={{ color: "green" }} />,
            //     onClick: () => editReimbursement(record._id),
            // });
            // }

            // // Delete Action (if not approved and has permission)
            // if (
            // record.statusFinal !== "Approved" &&
            // (getResource(config.RESOURCES.BILLREIMBURSEMENT, ["delete"]) ||
            //     getRoles(["Admin"]) ||
            //     authUser._id === record.createdBy)
            // ) {
            //     actions.push({
            //         key: "delete",
            //         label: "Delete",
            //         icon: <DeleteIcon />,
            //         needsConfirm: true,
            //         onClick: () => deleteReimbursement(record._id),
            //     });

            // }
            // // if () {
            // actions.push({
            //     key: "view",
            //     label: "View",
            //     icon: <ViewIcon style={{ color: "green" }} />,
            //     onClick: () => viewReimbursement(record._id),
            // });
            // // }


            // // === Display logic ===
            // if (actions.length === 0) {
            //   return <span>-</span>;
            // }

            // if (actions.length <= 3) {
            // // Directly show icons inline
            // return (
            //     <div style={{ display: "flex", gap: 4 }}>
            //     {actions.map((action) => {
            //         const button = (
            //         <Button
            //             key={action.key}
            //             type="link"
            //             onClick={action.needsConfirm ? undefined : action.onClick}
            //             style={{ padding: 4 }}
            //         >
            //             {action.icon}
            //         </Button>
            //         );

            //         if (action.needsConfirm) {
            //         return (
            //             <Tooltip key={action.key} title={action.label}>
            //             <Popconfirm
            //                 title="Are you sure you want to delete this?"
            //                 okText="Yes"
            //                 cancelText="No"
            //                 onConfirm={action.onClick}
            //             >
            //                 {button}
            //             </Popconfirm>
            //             </Tooltip>
            //         );
            //         }

            //         return (
            //         <Tooltip key={action.key} title={action.label}>
            //             {button}
            //         </Tooltip>
            //         );
            //     })}
            //     </div>
            // );
            // } else {
            // // More than two → show ellipsis dropdown
            // const menu = (
            //     actions.length > 0 ? <Menu
            //     items={actions.map((a) => ({
            //         key: a.key,
            //         label: a.needsConfirm ? (
            //         <Popconfirm
            //             title="Are you sure you want to delete this?"
            //             okText="Yes"
            //             cancelText="No"
            //             onConfirm={a.onClick}
            //         >
            //             <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            //             {a.icon}
            //             <span>{a.label}</span>
            //             </div>
            //         </Popconfirm>
            //         ) : (
            //         <div
            //             onClick={a.onClick}
            //             style={{
            //             display: "flex",
            //             alignItems: "center",
            //             gap: 8,
            //             }}
            //         >
            //             {a.icon}
            //             <span>{a.label}</span>
            //         </div>
            //         ),
            //     }))}
            //     /> : "-"
            // );

            // return (
            //     <Dropdown overlay={menu} trigger={["click"]}>
            //         <Tooltip title="More Actions" placement='bottom'>
            //     <Button type="text"  style={{ padding: 4 }}>
            //         <FaEllipsisVertical size={18} />
            //     </Button>
            //     </Tooltip>
            //     </Dropdown>
            // );
            // }
            // },

            render: (text, record) => {
                const actions = [];

                const canEdit =
                    record.statusFinal !== "Approved" &&
                    record.statusbyRM !== "Approved";

                const canDelete =
                    record.statusFinal !== "Approved" &&
                    (getResource(config.RESOURCES.BILLREIMBURSEMENT, ["delete"]) ||
                        getRoles(["Admin"]));

                const canView = true; // always

                const actionMap = {
                    edit: {
                        key: "edit",
                        label: "Edit",
                        icon: <EditIcon style={{ color: "green" }} />,
                        onClick: () => editReimbursement(record._id)
                    },
                    delete: {
                        key: "delete",
                        label: "Delete",
                        icon: <DeleteIcon />,
                        className: 'delete-popover',
                        needsConfirm: true,
                        onClick: () => deleteReimbursement(record._id)
                    },
                };

                // ==== PUSH ACTIONS IN FIXED ORDER ====

                if (canEdit) actions.push("edit");
                if (canDelete) actions.push("delete");

                // ==== RENDER ====

                // No actions → show dash
                if (actions.length === 0) return <span>-</span>;

                // Show inline if <= 3 actions
                if (actions.length <= 3) {
                    return (
                        <div style={{ display: "flex", gap: 4 }}>
                            {actions.map((key) => {
                                const a = actionMap[key];
                                const btn = (
                                    <Button
                                        key={a.key}
                                        type="link"
                                        onClick={a.needsConfirm ? undefined : a.onClick}
                                        style={{ padding: 4 }}
                                    >
                                        {a.icon}
                                    </Button>
                                );

                                if (a.needsConfirm) {
                                    return (
                                        <Tooltip key={a.key} title={a.label}>
                                            <Popconfirm
                                                title="Are you sure you want to delete this?"
                                                okText="Yes"
                                                cancelText="No"
                                                overlayClassName="stop-row-click-popconfirm"
                                                onConfirm={a.onClick}
                                            >
                                                {btn}
                                            </Popconfirm>


                                        </Tooltip>
                                    );
                                }

                                return (
                                    <Tooltip key={a.key} title={a.label}>
                                        {btn}
                                    </Tooltip>
                                );
                            })}
                        </div>
                    );
                }

                // More than three → dropdown
                const menu = (
                    <Menu
                        items={actions.map((key) => {
                            const a = actionMap[key];
                            return {
                                key: a.key,
                                label: a.needsConfirm ? (
                                    <Popconfirm
                                        title="Are you sure you want to delete this?"
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={a.onClick}
                                    >
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            {a.icon}
                                            <span>{a.label}</span>
                                        </div>
                                    </Popconfirm>
                                ) : (
                                    <div
                                        onClick={a.onClick}
                                        style={{ display: "flex", alignItems: "center", gap: 8 }}
                                    >
                                        {a.icon}
                                        <span>{a.label}</span>
                                    </div>
                                )
                            };
                        })}
                    />
                );

                return (
                    <Dropdown
                        overlay={menu}
                        trigger={["click"]}
                        open={openPopoverId === record._id}
                        onOpenChange={(visible) => {
                            if (visible) setOpenMenuKey(null);
                            setOpenPopoverId(visible ? record._id : null);
                        }}
                    >
                        <Tooltip title="More Actions" placement="bottom">
                            <Button type="text" style={{ padding: 4 }}>
                                <FaEllipsisVertical size={18} />
                            </Button>
                        </Tooltip>
                    </Dropdown>
                );
            }

        },
    ];

    const formatClaimDate = (value) => (value ? moment(value).format(dateFormat) : '-');

    // Optional columns beyond the ones shown by default - every field here is
    // already returned by /claim/claim-user (see Claim.js getUserClaims
    // $project), so no extra API calls are needed to offer them.
    const extraColumns = [
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: 220,
            ellipsis: true,
            render: (text) => text || '-',
        },
        {
            title: 'Claim Type(s)',
            dataIndex: 'entries',
            key: 'entries',
            width: 200,
            ellipsis: true,
            render: (entries) => {
                if (!entries || entries.length === 0) return '-';
                const types = [...new Set(entries.map((entry) => entry?.claimType).filter(Boolean))];
                return types.length > 0 ? types.join(', ') : '-';
            },
        },
        {
            title: 'RM Status',
            dataIndex: 'statusbyRM',
            key: 'statusbyRM',
            width: 140,
            render: (status) => getStatusTag(status),
        },
        {
            title: 'Admin Status',
            dataIndex: 'statusbyAdmin',
            key: 'statusbyAdmin',
            width: 140,
            render: (status) => getStatusTag(status),
        },
        {
            title: 'RM Action Date',
            dataIndex: 'rmActionAt',
            key: 'rmActionAt',
            width: 150,
            render: (date) => formatClaimDate(date),
        },
        {
            title: 'Admin Action Date',
            dataIndex: 'adminActionAt',
            key: 'adminActionAt',
            width: 160,
            render: (date) => formatClaimDate(date),
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 140,
            render: (date) => formatClaimDate(date),
        },
    ];

    // `columns` ends with the fixed Actions column - slot the optional columns
    // in ahead of it so Actions stays as the last column instead of visually
    // splitting the table from whatever gets toggled on after it.
    const actionsColumnDef = columns[columns.length - 1];
    const coreColumnDefs = columns.slice(0, -1);
    const allColumnDefs = [...coreColumnDefs, ...extraColumns, actionsColumnDef];
    const extraColumnKeys = extraColumns.map((col) => col.key);

    const {
        visibleKeys: visibleColumnKeys,
        saveVisibleKeys: saveVisibleColumnKeys,
        filteredColumns,
        saving: savingColumnPreference,
    } = useColumnVisibility("billReimbursement", allColumnDefs, extraColumnKeys, ["title", "actions"]);

    // Modal handlers
    const openAddModal = () => {
        // addForm.resetFields();
        // setAttachments([]);
        // setIsAddModalOpen(true);
        history.push(`/${companySlug}/bill-reimbursement/add`);
    };

    const closeAddModal = () => {
        setIsAddModalOpen(false);
        addForm.resetFields();
        setAttachments([]);
        form.resetFields()
    };

    const editReimbursement = async (id) => {
        history.push(`/${companySlug}/bill-reimbursement/edit/${id}`);
        // try {
        //     const response = await Service.makeAPICall({
        //         methodName: Service.getMethod,
        //         api_url: Service.detail_reimbursement + '/' + id,
        //     });

        //     if (response && response.data && response.data.data) {
        //         const reimbursementDetails = response.data.data;

        //         editForm.setFieldsValue({
        //             title: reimbursementDetails.title,
        //             date: moment(reimbursementDetails.date),
        //             description: reimbursementDetails.description || '',
        //         });

        //         setSelectedRecord(reimbursementDetails);
        //         setIsEditModalOpen(true);
        //     }
        // } catch (error) {
        //     console.log(error);
        //     message.error('Failed to fetch reimbursement details');
        // }
    };

    // const exportReimbursementsCSV = async () => {
    //     try {
    //       dispatch(showAuthLoader());

    //       // Build the request body with correct filter data
    //       const body = {
    //         title: searchRef || "",
    //         status: "",
    //         createdBy: "",
    //         from_date: filterData?.fromDate ? moment(filterData.fromDate).format("YYYY-MM-DD") : "",
    //         to_date: filterData?.toDate ? moment(filterData.toDate).format("YYYY-MM-DD") : "",
    //       };

    //       const response = await Service.makeAPICall({
    //         methodName: Service.postMethod,
    //         api_url: Service.exportReimbursementsCSV,
    //         body: body,
    //       });

    //       dispatch(hideAuthLoader());

    //       // Check response structure
    //       if (response?.data?.status === 200 && response.data.data) {
    //         const base64 = response.data.data;
    //         const linkSource = "data:text/csv;base64," + base64;
    //         const downloadLink = document.createElement("a");
    //         const fileName = "Reimbursements.csv";

    //         downloadLink.href = linkSource;
    //         downloadLink.download = fileName;
    //         downloadLink.style.display = "none";
    //         document.body.appendChild(downloadLink);
    //         downloadLink.click();
    //         document.body.removeChild(downloadLink);

    //         message.success(response.data.message || "Export successful");
    //       } else {
    //         message.error(response?.data?.message || "Failed to export CSV");
    //         console.log("Export response:", response);
    //       }
    //     } catch (error) {
    //       console.error("Export CSV Error:", error);
    //       dispatch(hideAuthLoader());
    //       message.error("Failed to export CSV");
    //     }
    //   };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        editForm.resetFields();
        setAttachments([]);
        form.resetFields()
        setSelectedRecord({});
    };

    const viewReimbursement = async (id) => {
        // try {
        //     const response = await Service.makeAPICall({
        //         methodName: Service.getMethod,
        //         api_url: Service.detail_reimbursement + '/' + id,
        //     });

        //     if (response && response.data && response.data.data) {
        //         const reimbursementDetails = response.data.data;

        //         viewForm.setFieldsValue({
        //             title: reimbursementDetails.title,
        //             date: moment(reimbursementDetails.date),
        //             description: reimbursementDetails.description || '-',
        //         });

        //         setSelectedRecord(reimbursementDetails);
        //         setIsViewModalOpen(true);
        //     }
        // } catch (error) {
        //     console.log(error);
        //     message.error('Failed to fetch reimbursement details');
        // }

        history.push(`/${companySlug}/bill-reimbursement/view/${id}`);
    };

    const closeViewModal = () => {
        setIsViewModalOpen(false);
        viewForm.resetFields();
        form.resetFields()
        setSelectedRecord({});
    };

    // API functions
    const fetchReimbursements = async () => {
        try {
            dispatch(showAuthLoader());

            // Build query parameters safely
            const params = new URLSearchParams({
                page: pagination.current,
                limit: pagination.pageSize,
                from_date: filterData?.fromDate || "",
                to_date: filterData?.toDate || "",
            }).toString();

            const response = await Service.makeAPICall({
                methodName: Service.getMethod,
                api_url: `${Service.fetchReimbursements}?${params}`,
            });

            if (response?.data) {
                setReimbursementData(response.data.data || []);
                setTotalRecords(response.data.totalData || 0);
            }

            dispatch(hideAuthLoader());
        } catch (error) {
            console.error("Fetch Reimbursements Error:", error);
            dispatch(hideAuthLoader());
            message.error("Failed to fetch reimbursements");
        }
    };

    const addReimbursement = async (values) => {
        try {
            dispatch(showAuthLoader());
            console.log(values, 'values', authUser?._id, Service.add_reimbursement);

            const formData = new FormData();
            formData.append('title', values.title);
            formData.append("amount", values.amount);

            formData.append('date', values.date.format('YYYY-MM-DD'));
            formData.append('description', values.description || '');
            formData.append('createdBy', authUser?._id);
            console.log(attachments, 'attachmentsattachments', attachments);

            if (attachments.length > 0) {
                attachments.forEach((file) => {
                    formData.append('attachments', file);

                });
            } else {
                message.error('Please upload at least one attachment');
                dispatch(hideAuthLoader());
                return;
            }

            const response = await Service.makeAPICall({
                methodName: Service.postMethod,
                api_url: Service.add_reimbursement,
                body: formData,
            });

            console.log(response, 't');

            if (response && response.status) {
                message.success('Reimbursement added successfully');
                closeAddModal();
                fetchReimbursements()
                setAttachments([]);
            } else {
                message.error(response.message || 'Failed to add reimbursement');
            }

            dispatch(hideAuthLoader());
        } catch (error) {
            console.log(error);
            dispatch(hideAuthLoader());
            message.error('Something went wrong. Please try again');
        }
    };

    const handleFilterChange = (changedValues, allValues) => {
        const filterPayload = {};

        if (allValues.dateRange && allValues.dateRange.length === 2) {
            filterPayload.fromDate = allValues.dateRange[0].startOf('day').toISOString();
            filterPayload.toDate = allValues.dateRange[1].endOf('day').toISOString();
        }

        if (allValues.status && allValues.status.length > 0) {
            filterPayload.status = allValues.status;
        }

        setFilterData(Object.keys(filterPayload).length > 0 ? filterPayload : null);
        setPagination(prev => ({ ...prev, current: 1 }));
    };

    const openFilterModal = () => {
        const formValues = {
            dateRange: filterData?.fromDate && filterData?.toDate
                ? [moment(filterData.fromDate), moment(filterData.toDate)]
                : null
        };
        form.setFieldsValue(formValues);
        setIsFilterModalOpen(true);
    };

    const onModalReset = () => {
        form.resetFields();
    };

    const handleFilterApply = (values) => {
        const filterPayload = {};

        if (values.dateRange && values.dateRange.length === 2) {
            filterPayload.fromDate = values.dateRange[0].startOf('day').toISOString();
            filterPayload.toDate = values.dateRange[1].endOf('day').toISOString();
        }

        if (values.status && values.status.length > 0) {
            filterPayload.status = values.status;
        }

        setFilterData(Object.keys(filterPayload).length > 0 ? filterPayload : null);
        setPagination(prev => ({ ...prev, current: 1 }));
        setIsFilterModalOpen(false);
    };

    const onFilterReset = () => {
        form.resetFields();
        setFilterData(null);
        setPagination(prev => ({ ...prev, current: 1 }));
        fetchReimbursements();
    };
    const fetchSearchDta = async () => {
        try {
            dispatch(showAuthLoader());
            // const searchValue = searchRef.current?.value || ""; 

            const response = await Service.makeAPICall({
                methodName: Service.getMethod,
                api_url: Service.fetchReimbursements + `?search=${searchRef}`,

            });

            if (response && response.data) {
                setReimbursementData(response.data.data || []);
                setTotalRecords(response.data.totalData || 0);
            }

            dispatch(hideAuthLoader());
        } catch (error) {
            console.log(error);
            dispatch(hideAuthLoader());
            message.error('Failed to fetch reimbursements');
        }
    };


    const deleteReimbursement = async (id) => {
        try {
            dispatch(showAuthLoader());

            const response = await Service.makeAPICall({
                methodName: Service.deleteMethod,
                api_url: Service.deleteClaim + '/' + id,
            });

            if (response && response.status) {
                message.success('Reimbursement deleted successfully');
                fetchReimbursements();
            } else {
                message.error(response.message || 'Failed to delete reimbursement');
            }

            dispatch(hideAuthLoader());
        } catch (error) {
            console.log(error);
            dispatch(hideAuthLoader());
            message.error('Something went wrong. Please try again');
        }
    };

    const updateReimbursement = async (values) => {
        try {
            dispatch(showAuthLoader());

            if (!values.title || !values.date) {
                dispatch(hideAuthLoader());
                return message.error("Please fill all required fields");
            }

            const formData = new FormData();
            formData.append("title", values.title);
            formData.append("amount", values.amount);

            formData.append("date", values.date.format("YYYY-MM-DD"));

            formData.append("description", values.description || "");
            formData.append("updatedBy", authUser?._id);

            // **Append new attachments**
            attachments.forEach((file) => {
                formData.append("attachments", file);
            });

            // **Pass deleted attachments**
            if (deletedAttachments.length > 0) {
                formData.append("deletedAttachments", JSON.stringify(deletedAttachments));
            }
            console.log(formData, 'formData');

            // **Make API call**
            const response = await Service.makeAPICall({
                methodName: Service.putMethod,
                api_url: `${Service.update_reimbursement}/${selectedRecord?._id}`,
                body: formData,
            });

            if (response && response.status) {
                message.success(response.data.message);
                closeEditModal();
                fetchReimbursements();
            } else {
                message.error(response.message || "Failed to update reimbursement");
            }
        } catch (error) {
            console.error("Update error:", error);
            message.error("Something went wrong. Please try again");
        } finally {
            dispatch(hideAuthLoader());
        }
    };

    const handleFileUpload = (event) => {
        const files = Array.from(event.target.files);
        setAttachments(prevAttachments => [...prevAttachments, ...files]);
    };


    const removeAttachment = (filename) => {
        setDeletedAttachments((prev) => [...prev, filename]);

        setAttachments((prev) =>
            prev.filter((file) => {
                if (file.name) {
                    return file.name !== filename;
                }
                return file !== filename;
            })
        );

        setSelectedRecord((prev) => ({
            ...prev,
            attachments: prev.attachments.filter((att) => att !== filename),
        }));
    };


    const handleTableChange = (page, pageSize) => {
        setPagination({
            current: page,
            pageSize: pageSize,
        });
    };
    const handleFileChange = ({ fileList }) => {
        setFileList(fileList);
    };

    // const approveReimbursements = async () => {
    //     try {
    //         dispatch(showAuthLoader());

    //         if (selectedRowKeys.length === 0) {
    //             dispatch(hideAuthLoader());
    //             return message.error("Please select at least one reimbursement to approve.");
    //         }

    //         // **Prepare API body**
    //         const payload = {
    //             reimbursementIds: selectedRowKeys,
    //             status: "Approved",
    //             updatedBy: authUser._id,
    //         };


    //         const response = await Service.makeAPICall({
    //             methodName: Service.putMethod,
    //             api_url: `${Service.updateReimbursementStatus}`,
    //             body: JSON.stringify(payload),
    //         });

    //         // **Handle response**
    //         if (response && response.status) {
    //             message.success(response.data.message);
    //             setSelectedRowKeys([]);
    //             fetchReimbursements();
    //         } else {
    //             message.error(response.message || "Failed to approve reimbursements.");
    //         }
    //     } catch (error) {
    //         console.error("❌ Approval error:", error);
    //         message.error("Something went wrong. Please try again.");
    //     } finally {
    //         dispatch(hideAuthLoader());
    //     }
    // };
    // const rejectReimbursements = async () => {
    //     try {
    //         dispatch(showAuthLoader());

    //         if (selectedRowKeys.length === 0) {
    //             dispatch(hideAuthLoader());
    //             return message.error("Please select at least one reimbursement to approve.");
    //         }

    //         const payload = {
    //             reimbursementIds: selectedRowKeys,
    //             status: "Rejected",
    //             updatedBy: authUser._id,
    //         };


    //         const response = await Service.makeAPICall({
    //             methodName: Service.putMethod,
    //             api_url: `${Service.updateReimbursementStatus}`,
    //             body: JSON.stringify(payload),
    //         });

    //         if (response && response.status) {
    //             message.success(response.data.message);
    //             setSelectedRowKeys([]);
    //             fetchReimbursements();
    //         } else {
    //             message.error(response.message || "Failed to approve reimbursements.");
    //         }
    //     } catch (error) {
    //         console.error("❌ Approval error:", error);
    //         message.error("Something went wrong. Please try again.");
    //     } finally {
    //         dispatch(hideAuthLoader());
    //     }
    // };


    useEffect(() => {
        fetchReimbursements();
    }, [pagination.current, pagination.pageSize, filterData]);

    useEffect(() => {
        if (searchRef == '') {
            fetchReimbursements();
        }
    }, [searchRef])


    return (
        <>
            <Card className='employee-card'>
                <div className=" inout-header text-left">
                    <h2>Bill Reimbursements </h2>
                    <div className='header-btns'>
                        {(getResource(config.RESOURCES.BILLREIMBURSEMENT, ["create"]) || getRoles(["Admin"]))
                            ? (
                                <>
                                    <Button icon={<PlusOutlined />} onClick={openAddModal} type="primary">
                                        Reimbursement
                                    </Button>
                                </>
                            ) : ""}
                    </div>
                </div>
                <Card className="main-content-wrapper" >
                    <div className='search-wrapper'>
                        <Search
                            onChange={(e) => setsearchRef(e.target.value)}
                            placeholder="Search..."
                            onSearch={fetchSearchDta}
                            style={{ width: 200 }}
                            className="mr2"
                        />
                        <div className='filter-btns-wrapper'>
                            <Button
                                type="primary"
                                onClick={openFilterModal}
                                className="filter-btn"
                            >
                                Filter
                            </Button>
                            <Button
                                className="delete-btn"
                                onClick={onFilterReset}
                                disabled={!hasAnyValue}
                            >
                                Reset
                            </Button>
                            <ColumnSelector
                                columns={allColumnDefs}
                                visibleKeys={visibleColumnKeys}
                                onSave={saveVisibleColumnKeys}
                                alwaysVisibleKeys={["title", "actions"]}
                                open={openMenuKey === "columns"}
                                onOpenChange={(visible) => handleToolbarMenuOpenChange("columns", visible)}
                                saving={savingColumnPreference}
                            />
                            {/* { getResource(config.RESOURCES.BILLREIMBURSEMENT, ["update"]) ? (
                                < >
                                    <Button type='primary' className="add-btn" disabled={selectedRowKeys.length > 0 ? false : true} onClick={approveReimbursements}>
                                        Approve
                                    </Button>
                                    <Button className=" ant-reject" disabled={selectedRowKeys.length > 0 ? false : true} onClick={rejectReimbursements}>
                                        Reject
                                    </Button>
                                </>
                            ) : "" } */}
                            {/* <Button className="mr2 btn-secondary "
                    type="primary"
                    id="exportButton"
                               // disabled={ selectedRowKeys.length > 0 ? false : true }
                                onClick={ exportReimbursementsCSV }>
                                        Export CSV
                                    </Button> */}
                        </div>
                    </div>
                    {/* Add Reimbursement Modal */}
                    <Modal
                        title="Add Bill Reimbursement"
                        width={800}
                        open={isAddModalOpen}
                        footer={[
                            <Button key="submit" type="primary" htmlType="submit" onClick={() => form.submit()}>
                                Submit
                            </Button>
                        ]}
                        onCancel={closeAddModal}
                        style={{ top: "40px" }}
                    >
                        <Form form={form} onFinish={addReimbursement} layout="vertical">
                            <div className="main-form-wrapper">
                                <div className="form-container">
                                    {/* Row 1: Title and Date */}
                                    <div className="form-row">
                                        <div className="form-col">
                                            <div className="form-item">
                                                <Form.Item
                                                    label="Title"
                                                    name="title"
                                                    rules={[{ required: true, message: 'Please enter title' }]}
                                                >
                                                    <Input placeholder="Enter title" />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="form-col">
                                            <div className="form-item">
                                                <Form.Item
                                                    label="Date"
                                                    name="date"
                                                    rules={[{ required: true, message: 'Please select date' }]}
                                                >
                                                    <DatePicker style={{ width: '100%' }} format="DD-MM-YYYY" />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Row 2: Description */}
                                    <div className="form-row">
                                        <div className="form-col-full">
                                            <div className="form-item">
                                                <Form.Item
                                                    label="Description"
                                                    name="description"
                                                >
                                                    <TextArea rows={4} placeholder="Enter description (optional)" />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Row 3: Add Attachments */}
                                    <div className="form-row">
                                        <div className="form-col-full">
                                            <div className="form-item">
                                                <Form.Item
                                                    label="Attachments"
                                                    name="attachments"
                                                    rules={[{ required: true, message: 'Please upload at least one file' }]}
                                                >
                                                    <div>
                                                        <input
                                                            type="file"
                                                            multiple
                                                            onChange={handleFileUpload}
                                                        />
                                                        <div style={{ marginTop: 8 }}>
                                                            {attachments.length > 0 && (
                                                                <div>
                                                                    <p>Selected files:</p>
                                                                    <ul>
                                                                        {attachments.map((file, index) => (
                                                                            <li key={index}>{file.name}</li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </Modal>

                    {/* Edit Reimbursement Modal */}

                    <Modal
                        title="Edit Bill Reimbursement"
                        width={800}
                        open={isEditModalOpen}
                        footer={[
                            <>
                                <Button className="ant-delete" onClick={() => setIsEditModalOpen(false)}>
                                    Cancel
                                </Button>

                                <Button key="update" type="primary" htmlType="submit" onClick={() => editForm.submit()}>
                                    Update
                                </Button>
                            </>
                        ]}
                        onCancel={closeEditModal}
                        style={{ top: "40px" }}
                    >
                        <Form form={editForm} onFinish={updateReimbursement} className='modal-form-col' layout="vertical">
                            <Row gutter={[16, 0]}>
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label="Title"
                                        name="title"
                                        rules={[{ required: true, message: 'Please enter title' }]}
                                    >
                                        <Input placeholder="Enter title" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label="Date"
                                        name="date"
                                        rules={[{ required: true, message: 'Please select date' }]}
                                    >
                                        <DatePicker style={{ width: '100%' }} format="DD-MM-YYYY" />
                                    </Form.Item>
                                </Col>



                                {/* Row 3: Existing Attachments */}
                                {selectedRecord.attachments && selectedRecord.attachments.length > 0 && (

                                    <Col xs={24} md={12}>
                                        <h4>Existing Attachments:</h4>
                                        <ul className='file-attachment'>
                                            {selectedRecord.attachments.map((attachment, index) => (
                                                <li key={index}>
                                                    <a
                                                        href={`${process.env.REACT_APP_API_URL}/uploads/reimbursements/${attachment}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {attachment}
                                                    </a>
                                                    <Button
                                                        className='delete-btn'
                                                        icon={<DeleteIcon />}
                                                        size="small"
                                                        onClick={() => removeAttachment(attachment)}
                                                    >

                                                    </Button>
                                                </li>
                                            ))}
                                        </ul>
                                    </Col>

                                )}

                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label="Add New Attachments"
                                        name="new_attachments"
                                    >
                                        <div>
                                            <input
                                                type="file"
                                                multiple
                                                onChange={handleFileUpload}
                                            />
                                            <div style={{ marginTop: 8 }}>
                                                {attachments.length > 0 && (
                                                    <div>
                                                        <p>Selected files:</p>
                                                        <ul>
                                                            {attachments.map((file, index) => (
                                                                <li key={index}>{file.name}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} >

                                    <Form.Item
                                        label="Description"
                                        name="description"
                                    >
                                        <TextArea rows={4} placeholder="Enter description (optional)" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Modal>

                    {/* View Reimbursement Modal */}
                    <Modal
                        title="View Bill Reimbursement"
                        width={800}
                        open={isViewModalOpen}
                        footer={[
                            <Button key="close" className='delete-btn' onClick={closeViewModal}>
                                Close
                            </Button>
                        ]}
                        onCancel={closeViewModal}
                        style={{ top: "40px" }}
                    >
                        <Form form={viewForm} layout="vertical">
                            <div className="main-form-wrapper">
                                <div className="form-container">
                                    {/* Row 1: Description */}
                                    <div className="form-row">
                                        <div className="form-col">
                                            <div className="form-item">
                                                <Form.Item
                                                    label="Description"
                                                    name="description"
                                                >
                                                    <TextArea rows={4} disabled />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Row 2: Attachments */}
                                    {selectedRecord.attachments && selectedRecord.attachments.length > 0 && (
                                        <div className="form-row">
                                            <div className="form-col">
                                                <div className="form-item">
                                                    <div style={{ marginBottom: 16 }}>
                                                        <h4>Attachments:</h4>
                                                        <ul>
                                                            {selectedRecord.attachments.map((attachment, index) => (
                                                                <li key={index}>
                                                                    <a
                                                                        href={`${process.env.REACT_APP_API_URL}/uploads/reimbursements/${attachment}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {attachment.originalname || `Attachment ${index + 1}`}
                                                                    </a>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Form>
                    </Modal>
                    <div className='main-table-wrapper'>


                        <Table
                            columns={filteredColumns}
                            scroll={{ x: "max-content" }}
                            dataSource={reimbursementData}
                            pagination={{
                                ...TABLE_PAGINATION,
                                ...pagination,
                                total: totalRecords,
                                onChange: (page, pageSize) => handleTableChange(page, pageSize),
                            }}
                            rowKey="_id"
                            onRow={(record) => {
                                return {
                                    onClick: (event) => {
                                        if (
                                            event.target.closest('.stop-row-click-popconfirm')
                                        ) {
                                            return;
                                        }
                                        const isActionColumn = event.target.closest('.ant-table-cell')?.classList.contains('actions-column');

                                        if (!isActionColumn) {
                                            history.push(`/${companySlug}/bill-reimbursement/view/${record._id}`);
                                        }
                                    },
                                    style: { cursor: 'pointer' },
                                };
                            }}
                            footer={() => <div>Total Records Count:{totalRecords}</div>}
                            rowClassName={(record) =>
                                record?.isStatus == "approved" ? "disabled-row" : ""
                            }
                        // onRow={(record) => {
                        //   return {
                        //     onClick: (event) => {
                        //       const cell = event.target.closest('.ant-table-cell');
                        //       const isActionColumn = cell?.classList.contains('actions-column');
                        //       const isAttachmentsColumn = cell?.classList.contains('attachments-column');
                        //       if (!isActionColumn && !isAttachmentsColumn) {
                        //         viewReimbursement(record._id);
                        //       }
                        //     },
                        //     style: { cursor: 'pointer' },
                        //   };
                        // }}
                        />

                    </div>
                </Card>
            </Card>

            <Modal
                title="Filter"
                width={600}
                open={isFilterModalOpen}
                onCancel={() => setIsFilterModalOpen(false)}
                footer={[
                    <Button key="cancel" className="ant-delete" onClick={() => setIsFilterModalOpen(false)}>
                        Cancel
                    </Button>,
                    <Button key="reset" className="ant-delete" onClick={onModalReset}>
                        Reset
                    </Button>,
                    <Button key="apply" type="primary" onClick={() => form.submit()}>
                        Apply
                    </Button>,
                ]}

            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFilterApply}
                    initialValues={{
                        dateRange: null,
                        status: []
                    }}
                >

                    <Form.Item
                        label="Date Range"
                        name="dateRange"
                    >
                        <RangePicker
                            style={{ width: '100%' }}
                            format="DD-MM-YYYY"
                        />
                    </Form.Item>

                </Form>
            </Modal>
        </>
    );
};
export default BillReimbursement